import React from 'react';

interface CountProps {
  total?: number;
}

export default function Count({ total = 0 }: CountProps) {
  if (total === 0) return null;

  return (
    <div className="orgchart-card-count">
      <div className="orgchart-card-count-value">{total}</div>
    </div>
  );
}
